import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { SourceSystemType } from '../../../../foundation/models/enums/source-system-type.enum';
import { BaseComponent } from '../../../../shared/base-components/base.component';
import { AuxRoute } from '../../../../shared/models/route/aux-route.model';
import { OmnisearchModel } from '../../../../shared/models/search/omnisearch.model';
import { MvdModalService } from '../../../../shared/services/modal/mvd-modal.service';
import { PlateStatusType } from '../../../models/enums/plate-status-type.enum';
import { VehicleOwnershipPlateStatusType } from '../../../models/enums/vehicle-ownership-plate-status-type.enum';
import { PlateSearchResultModel } from '../../../models/plate-search-result.model';
import { PlateModel } from '../../../models/plate.model';
import { PlateService } from '../../../services/plate.service';

@Component({
    selector: 'plate-search',
    templateUrl: './plate-search.html',
})
export class PlateSearchComponent extends BaseComponent {
    @Output() onVehicleSelected: EventEmitter<OmnisearchModel> = new EventEmitter<OmnisearchModel>();

    public canManualUnReserve: boolean;
    public hasSearched = false;
    public isExactMatch = true;
    public manualUnReserveMessage: string;
    public plateSearchString: string;
    public results: PlateSearchResultModel[] = [];
    public vehicleOwnershipPlateStatusTypes = new VehicleOwnershipPlateStatusType().GetAll();
    private reservedPlateStatusTypes = [
        new PlateStatusType().Reserved.id,
        new PlateStatusType().AllocatedReserved.id,
        new PlateStatusType().ConvertedReserved.id
    ];

    constructor(private plateService: PlateService, private router: Router, public modalService: MvdModalService) {
        super();
    }

    public ngOnInit() {}

    public onPlateNumberClicked(vehicleOwnershipId: number) {
        this.navigate(vehicleOwnershipId);
    }

    public plateSearchClicked = (): void => {
        this.manualUnReserveMessage = null;
        this.canManualUnReserve = null;
        this.plateService.getPlateSearchResultByPlateNumber(this.plateSearchString, this.isExactMatch)
            .subscribe(
                result => this.displayOrNavigate(result),
                err => console.log(err));
    };

    public resetSearch() {
        this.results = [];
        this.plateSearchString = null;
        this.hasSearched = false;
    }

    public unreserve() {
        let self = this;
        this.modalService.confirm()
            .okBtn('Remove')
            .cancelBtn('Cancel')
            .title('Remove Reservation')
            .body('Are you sure you wish to remove the reservation for this plate?')
            .open().afterClosed()
            .subscribe(
                result => {
                    if (result) {
                        let plateModel = new PlateModel();
                        plateModel.plateNumber = self.plateSearchString;
                        this.plateService.manualUnReserve(plateModel)
                            .subscribe(
                                r => {
                                    self.canManualUnReserve = r.canManualUnReserve;
                                    self.manualUnReserveMessage = r.manualUnReserveMessage;
                                    if (!self.manualUnReserveMessage) {
                                        self.hasSearched = false;
                                    }
                                },
                                err => {
                                    self.onFailure('assign-plate save', err);
                                }
                            );
                    }
                }
            );

    }

    private displayOrNavigate(plateSearchResults: PlateSearchResultModel[]) {
        this.hasSearched = true;
        if (plateSearchResults.length === 1) {
            this.handleBasedOnPlateStatusType(plateSearchResults[0]);
        } else {
            this.results = plateSearchResults;
        }
    }

    private handleBasedOnPlateStatusType(selectedPlate: PlateSearchResultModel) {
        if (this.reservedPlateStatusTypes.includes(selectedPlate.plateStatusTypeId)) {
            this.manualUnReserveMessage = selectedPlate.manualUnReserveMessage;
            this.canManualUnReserve = selectedPlate.canManualUnReserve;
        } else if (selectedPlate.plateStatusTypeId == new PlateStatusType().Allocated.id) {
            this.manualUnReserveMessage = 'Plate is ready to be used.  Select "Assign Plate" during the service.';
            this.canManualUnReserve = false;
        } else {
            this.results = [selectedPlate];
            this.navigate(selectedPlate.vehicleOwnershipId);
        }
    }

    private mapPlateSearchResultToOmnisearchModel(genResult: PlateSearchResultModel) {
        const result = new OmnisearchModel();
        result.makeDisplayValue = genResult.make;
        result.modelDisplayValue = genResult.model;
        result.modelYear = genResult.year;
        result.plateNumber = genResult.plateNumber;
        result.registrationEndDate = genResult.registrationEndDate;
        result.vehicleId = genResult.vehicleId;
        result.vin = genResult.vin;
        return result;
    }

    private navigate = (vehicleOwnershipId: number): void =>  {
        var result = this.results.find(x => x.vehicleOwnershipId == vehicleOwnershipId);
        if (result.vehicleOwnershipPlateStatusTypeId == new VehicleOwnershipPlateStatusType().Active.id) {
            this.onVehicleSelected.emit(this.mapPlateSearchResultToOmnisearchModel(result));
        } else {
            this.navigateToCustomerOwnedPlate(result.vehicleOwnershipId);
        }
    };

    private navigateToCustomerOwnedPlate = (vehicleOwnershipId: number): void => {
        const routeBuilder = this.routeBuilderFactory.create(new SourceSystemType().TitleRegistration.id);
        const auxRoutes: AuxRoute[] = new Array<AuxRoute>();
        const bodyRoute = new AuxRoute();
        bodyRoute.routeName = 'customer-owned-plate';
        bodyRoute.routeParameter = [vehicleOwnershipId];
        bodyRoute.outletName = 'body';
        bodyRoute.isModule = true;
        auxRoutes.push(bodyRoute);
        const outlets = routeBuilder.buildAuxiliaryRouteCommand(auxRoutes);
        this.router.navigate(['/titleregistration/standalone', outlets]);
    };
}
